module.exports = __webpack_public_path__ + "static/img/零代码开发@2x.91b68264.png";